import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  keyframes
} from '@homebotapp/hb-react-component-catalog'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSwipeable } from 'react-swipeable'
import { selectIsShortcutsDrawerOpen, setIsShortcutsDrawerOpen } from '../../../store/slices/navigation'
import { DrawerButton } from './DrawerButton'

const DRAWER_GUID = 'qpTtkwfJzxNtwGu9Cyo6Lw'

// Magic Number
const DRAWER_PLACEHOLDER_HEIGHT = '118px'

const bounceInKeyframes = keyframes`
  40% {transform: translateY(-115px);}
  100% {
    transform: translateY(calc(-${DRAWER_PLACEHOLDER_HEIGHT} - env(safe-area-inset-bottom)));
  }
`

export const MobileShortcutsDrawer = ({ isLoading, children }) => {
  const dispatch = useDispatch()

  const [animation, setAnimation] = useState('')
  const [vh, setVh] = useState(window.innerHeight * 0.92)

  const isShortcutsDrawerOpen = useSelector(selectIsShortcutsDrawerOpen)

  const onClose = () => {
    dispatch(setIsShortcutsDrawerOpen(false))
  }
  const onOpen = () => {
    dispatch(setIsShortcutsDrawerOpen(true))
  }

  const drawerSwipeHandlers = useSwipeable({
    onSwipedDown: event => {
      if (event.deltaY > 10 && event.velocity > 1) {
        onClose()
      }
    }
  })

  useEffect(() => {
    if (isLoading) return

    setAnimation(`${bounceInKeyframes} 1s ease 1.5s 1 forwards`)
  }, [isLoading])

  const toggle = () => {
    isShortcutsDrawerOpen ? onClose() : onOpen()
  }

  // This accounts for the built in top and bottom navigation for some browsers
  useEffect(() => {
    const handleResize = () => {
      const viewHeight = window.innerHeight
      const ninetyPercentVH = viewHeight * 0.92
      setVh(ninetyPercentVH)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <>
      <Box
        position='fixed'
        bottom={`-${DRAWER_PLACEHOLDER_HEIGHT}`}
        left='0px'
        right='0px'
        height={DRAWER_PLACEHOLDER_HEIGHT}
        bg='card-bg-layer-1'
        zIndex='modal'
        // The Dashboard sets a margin of 3rem on all of its children,
        // so we need to override that here.
        margin='0px !important'
        animation={animation}
        borderTopLeftRadius='md'
        borderTopRightRadius='md'
      >
        <DrawerButton
          onClick={toggle}
          isOpen={isShortcutsDrawerOpen}
          // Not sure why the importants are needed
          borderColor='neutral.200 !important'
          _dark={{
            borderColor: 'whiteAlpha.300 !important'
          }}
          borderTop='1px solid'
          borderBottomLeftRadius='0px'
          borderBottomRightRadius='0px'
        />
      </Box>
      <Drawer
        isOpen={isShortcutsDrawerOpen}
        onClose={toggle}
        placement='bottom'
        tracking={{
          guid: DRAWER_GUID,
          descriptor: 'Mobile Shortcuts Drawer'
        }}
      >
        <DrawerOverlay />

        <DrawerContent height={vh} {...drawerSwipeHandlers}>
          <DrawerCloseButton
            as={DrawerButton}
            width='100%'
            display='flex'
            paddingY='7'
            position='relative'
            h='10'
            top='0'
            right='0'
            fontSize='md'
            isOpen={isShortcutsDrawerOpen}
          />
          <DrawerBody>{children}</DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  )
}
